import { StandardEvents } from '@shopify/events';

// Informational progress only. BOGOS and Shopify remain the discount authority.
if (!customElements.get('rh-cap-progress')) {
 customElements.define('rh-cap-progress', class extends HTMLElement {
  connectedCallback() {
   this.controller = new AbortController();
   const options = { signal: this.controller.signal };
   this.update = () => { clearTimeout(this.timer); this.timer = setTimeout(() => this.refresh(), 300); };
   document.addEventListener(StandardEvents.cartLinesUpdate, event => {
    Promise.resolve(event.promise).then(this.update).catch(this.update);
   }, options);
   ['bogos:discount-added','bogos:cart-updated','fg-cart:end-process','fg-cart:auto-updated'].forEach(name => document.addEventListener(name, this.update, options));
   this.refresh();
  }
  disconnectedCallback() { this.controller?.abort(); clearTimeout(this.timer); }
  async refresh() {
   try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { signal: this.controller.signal });
    if (!response.ok) return;
    const cart = await response.json();
    const count = cart.items.filter(item => item.product_type === 'Caps').reduce((total, item) => total + item.quantity, 0);
    const remainder = count % 3;
    const text = !count ? 'Start your three: add any 3 caps to unlock the offer.'
     : !remainder ? `${count} caps in your cart. Check your cart for the applied discount.`
     : `${count} cap${count === 1 ? '' : 's'} in your cart. Add ${3 - remainder} more to complete ${count > 3 ? 'your next' : 'your'} set of 3.`;
    const status = this.querySelector('[aria-live]');
    if (status) status.textContent = text;
   } catch { /* Keep useful static instructions if cart refresh is unavailable. */ }
  }
 });
}
document.addEventListener('click', event => {
 const link = event.target.closest('a[href="#rh-cap-fit"]');
 if (link) { const details = document.getElementById('rh-cap-fit'); if (details) details.open = true; }
});
